import { NavLink, Outlet, useNavigate } from "react-router-dom"
import { LogOut, FileText, Mail, Settings, Search, Tag, Bookmark } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useLogout, useMe } from "@/hooks/useAuth"
import { cn } from "@/lib/utils"

const NAV = [
  { to: "/", icon: FileText, label: "Hot Papers" },
  { to: "/papers", icon: Search, label: "전체 검색" },
  { to: "/me/keywords", icon: Tag, label: "키워드" },
  { to: "/me/bookmarks", icon: Bookmark, label: "북마크" },
  { to: "/newsletters", icon: Mail, label: "뉴스레터" },
  { to: "/me", icon: Settings, label: "설정" },
]

export default function AppShell() {
  const { data: me } = useMe()
  const logout = useLogout()
  const nav = useNavigate()

  return (
    <div className="grid h-full grid-cols-[240px_1fr]">
      <aside className="flex h-full flex-col border-r border-border bg-card">
        <div className="bg-primary px-5 py-4 text-primary-foreground">
          <div className="flex items-center gap-2 text-lg font-bold tracking-tight">
            <span className="grid h-7 w-7 place-items-center rounded-md bg-white/15 text-sm font-extrabold">
              오논
            </span>
            오논
          </div>
          <div className="mt-0.5 text-xs font-medium text-primary-foreground/70">
            오늘의 논문
          </div>
        </div>
        <nav className="flex-1 px-2 py-3">
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                cn(
                  "mb-1 flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors",
                  isActive
                    ? "bg-accent text-primary font-semibold"
                    : "text-muted-foreground hover:bg-secondary",
                )
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <div className="mb-2 truncate text-xs text-muted-foreground" title={me?.email}>
            {me?.display_name || me?.email}
            {me?.role === "admin" && (
              <span className="ml-1 rounded bg-primary px-1.5 py-0.5 text-[10px] font-medium text-primary-foreground">
                admin
              </span>
            )}
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start"
            onClick={async () => {
              await logout.mutateAsync()
              nav("/login", { replace: true })
            }}
          >
            <LogOut className="h-4 w-4" /> 로그아웃
          </Button>
        </div>
      </aside>
      <main className="overflow-auto">
        <div className="mx-auto max-w-6xl px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
